var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nc-jumbotron"},[_c('p',[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }